import styled from 'styled-components'
import tw from 'tailwind.macro'

const StAside = styled.div`
  ${tw`sm:px-8 px-4 pt-2 pb-4 text-white`}
  .st-sep-1 {
    ${tw`border-gray-300 my-4 text-base font-bold block leading-tight`}
    border-bottom-width: 1px;
    border-style: solid;
  }
  p {
    letter-spacing: -0.4px;
  }
`

const StSep1 = styled.div`
  ${tw`border-gray-300 my-4`}
  border-bottom-width: 1px;
  border-style: solid;
`

export { StSep1, StAside }
